var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"grid-list-xs":""}},[(_vm.checkLogin === true)?_c('div',[_c('CheckoutUI')],1):_c('div',[_c('CheckoutLocalUI')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }